import React, { useEffect, useState } from 'react';
import { 
  Box, 
  Typography, 
  Paper, 
  CircularProgress,
  Alert,
  Button
} from '@mui/material';
import { waitlistApi } from '../services/api';
import { WaitlistEntry } from '../types';
import WaitlistList from '../components/waitlist/WaitlistList';
import { Link } from 'react-router-dom';

const MyWaitlist: React.FC = () => {
  const [waitlistEntries, setWaitlistEntries] = useState<WaitlistEntry[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchWaitlistEntries = async () => {
    try {
      setLoading(true);
      setError(null);
      const entries = await waitlistApi.getMy();
      console.log('Waitlist entries:', JSON.stringify(entries, null, 2));
      setWaitlistEntries(entries);
    } catch (err: any) {
      console.error('Error fetching waitlist entries:', err);
      setError(err.response?.data?.error || 'Failed to load waitlist entries. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchWaitlistEntries();
  }, []);

  return (
    <Box>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
        <Typography variant="h4">My Waitlist</Typography>
        <Button 
          variant="outlined" 
          component={Link} 
          to="/resources"
        >
          Browse Resources
        </Button>
      </Box>

      {loading ? (
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
          <CircularProgress />
        </Box>
      ) : error ? (
        <Alert severity="error">{error}</Alert>
      ) : (
        <>
          <Paper elevation={3} sx={{ p: 3, mb: 3 }}>
            <Typography variant="body1" gutterBottom>
              This page shows all your waitlist entries. You'll be notified when a resource becomes available.
            </Typography>
            <Typography variant="body2" color="text.secondary">
              You can cancel a waitlist entry or convert it to a reservation if the resource becomes available.
            </Typography>
          </Paper>

          <WaitlistList 
            entries={waitlistEntries} 
            onUpdate={fetchWaitlistEntries}
            showUser={false}
          />
        </>
      )}
    </Box>
  );
};

export default MyWaitlist;
